import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import CategoryQuickLinks from './components/CategoryQuickLinks';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="Organization" />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <LatestSection />
          <CategoryQuickLinks />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}